/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_TitleInputs */

const en_fc_home_features_title = /** @type {(inputs: Fc_Home_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the FilmCraft video editor can do`)
};

/**
* | output |
* | --- |
* | "What the FilmCraft video editor can do" |
*
* @param {Fc_Home_Features_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_title = /** @type {((inputs?: Fc_Home_Features_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_title(inputs)
});
export { fc_home_features_title as "fc.home.features.title" }